export const isPositiveNumber = (number: unknown) => {
  return Number(number) > 0;
};
